import { getEntrySearchForAttribution } from '../common/entryContext';

type RedTrackMode = 'live' | 'debug';

function resolveRedtrackClickId(store: ReturnType<typeof useKegelAnalyticStore>): string {
  if (store.clickId) {
    return store.clickId;
  }
  if (import.meta.client) {
    try {
      const entrySearch = getEntrySearchForAttribution();
      const search = entrySearch || globalThis.location.search;
      const fromUrl = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).get('rtkcid');
      if (fromUrl) {
        return fromUrl;
      }
    } catch {
      /* ignore */
    }
    try {
      const fromSession = sessionStorage.getItem('rtkclickid');
      if (fromSession && fromSession !== 'undefined') {
        return fromSession;
      }
    } catch {
      /* ignore */
    }
  }
  return '';
}

function resolveRedTrackMode(environment: string | undefined, queryMode: string | undefined): RedTrackMode {
  if (queryMode === 'live' || queryMode === 'debug') {
    return queryMode;
  }

  return environment === 'production' || environment === 'prod' ? 'live' : 'debug';
}

export function useRedTrack() {
  const URL = '/track';
  const { $logger } = useNuxtApp();
  const store = useKegelAnalyticStore();
  const route = useRoute();
  const { ENVIRONMENT } = useRuntimeConfig().public;

  async function track(eventName: string): Promise<void> {
    try {
      const clickid = resolveRedtrackClickId(store);
      const queryMode = route.query.rt_mode as string | undefined;
      const mode = resolveRedTrackMode(ENVIRONMENT, queryMode);
      const payload = {
        clickid,
        sum: 0,
        type: eventName,
      };
      const viewUrl = `${URL}/postback?clickid=${clickid}&sum=0&type=${eventName}`;

      if (mode === 'debug') {
        const sessionClickId = import.meta.client
          ? sessionStorage.getItem('rtkclickid')
          : undefined;

        /* eslint-disable no-console */
        console.groupCollapsed(`[RedTrack event] ${eventName}`);
        console.log('environment', ENVIRONMENT);
        console.log('url', viewUrl);
        console.log('payload', payload);
        console.log('storeClickId', store.clickId);
        console.log('sessionClickId', sessionClickId);
        console.log('timestamp', new Date().toISOString());
        console.groupEnd();
        /* eslint-enable no-console */
        return;
      }

      await $fetch(viewUrl);
    } catch (error: unknown) {
      $logger.note({
        category: 'redTrack',
        message: 'postback failed',
        level: 'warning',
        data: { event: eventName },
        cause: error,
      });
    };
  }

  return {
    track,
  };
}
